<div class="basic-indicator-form margin-8-bottom">

    <div class="conditions">
        <div class="conditions-container display-flex spacer">
            <div class="full-width">
                <div class="rows display-flex" *ngFor="let form of formGroupArr;let idx = index" @fadeInUp @scaleYOut
                    [class.margin-8-top]="formGroupArr[idx].get('isSymbolEnabled').value && idx == 0">

                    <form class="condition-row full-width" autocomplete="off">

                        <div class="row-condition display-flex-column" *ngIf="idx !== 0"
                            [class.pro]="(strategyMode$ | async) !== StrategyFormBuildMode.REGULAR">
                            <div class="bar"></div>

                            <mat-form-field class="ut-pro-mat-form-field label-field" appearance="outline"
                                color="accent">

                                <mat-select [formControl]="rowCondition[idx - 1]">
                                    <mat-option [value]="option.key" *ngFor="let option of AND_OR | keyvalue">
                                        {{ option.value }}
                                    </mat-option>
                                </mat-select>

                                <mat-error *ngIf="rowCondition[idx - 1].hasError('required')">
                                    Comparator is required
                                </mat-error>
                            </mat-form-field>
                        </div>


                        <div class="row-creation-controls responsive-flex flex-centered-container-vr">
                            <div class="reference-symbol display-flex search-symbol order-lots-checkbox flex-centered-container"
                                *ngIf="(strategyMode$ | async) !== StrategyFormBuildMode.REGULAR">
                                <mat-checkbox [formControl]="formGroupArr[idx].get('isSymbolEnabled')"
                                    [class.float]="formGroupArr[idx].get('isSymbolEnabled').value"
                                    (change)="checkIsSymbolChange($event, idx)">
                                    <span>
                                        Use Reference Symbol
                                    </span>
                                </mat-checkbox>

                                <mat-form-field class="full-width ut-pro-mat-form-field label-field"
                                    appearance="outline" color="accent"
                                    *ngIf="formGroupArr[idx].get('isSymbolEnabled').value">
                                    <label class="ut-label">Select Symbol</label>
                                    <mat-autocomplete #symbolAutoComplete="matAutocomplete"
                                        (optionSelected)="addSymbol($event, idx)">
                                        <mat-option *ngFor="let symbol of searchedSymbols" [value]="symbol">
                                            {{ symbol.market_id }} {{ symbol.scrip_name }}
                                        </mat-option>
                                    </mat-autocomplete>

                                    <input matInput #fruitInput="matAutocompleteTrigger"
                                        [matAutocomplete]="symbolAutoComplete" class="full-width reference-input"
                                        [errorStateMatcher]="errMatcher" (blur)="validateRefSymbol(idx)"
                                        [formControl]="formGroupArr[idx].get('symbol')">

                                    <mat-error *ngIf="formGroupArr[idx].get('symbol').hasError('required')">
                                        Symbol is required
                                    </mat-error>

                                    <mat-chip-list aria-label="Fruit selection" class="no-margin">
                                        <mat-chip *ngFor="let symbol of symbols" [removable]="true"
                                            (removed)="removeSymbol(symbol)">
                                            {{ symbol.market_id }} {{ symbol.scrip_name }}
                                            <mat-icon matChipRemove>cancel</mat-icon>
                                        </mat-chip>
                                    </mat-chip-list>
                                </mat-form-field>
                            </div>

                            <div class="joining-line"
                                [class.pro]="(strategyMode$ | async) !== StrategyFormBuildMode.REGULAR"></div>
                            <mat-form-field class="ut-pro-mat-form-field label-field spacer" appearance="outline"
                                color="accent">
                                <label class="ut-label">
                                    {{ formGroupArr[idx].get('indicatorA').value
                                    && !isNotNumber(formGroupArr[idx].get('indicatorA').value) ?'Value' : 'Indicator'}}
                                </label>
                                <mat-autocomplete #indicatorAAutoComplete="matAutocomplete"
                                    (optionSelected)="openValueDialog(idx, false, indicatorATrigger); getIndicators()">
                                    <mat-option *ngFor="let indicator of indicatorList" [value]="indicator.name">
                                        <span [matTooltip]="indicator.description" matTooltipPosition="right"
                                            class=" padding-right ">{{ indicator.name }}</span>
                                    </mat-option>
                                </mat-autocomplete>

                                <input matInput #indicatorATrigger="matAutocompleteTrigger"
                                    [matAutocomplete]="indicatorAAutoComplete" class="full-width"
                                    [formControl]="formGroupArr[idx].get('indicatorA')"
                                    (blur)="validateIndicatorInput(idx)" (focus)="getIndicators()"
                                    (keydown)="checkFilterEvent($event)"
                                    (keyup.backspace)="getIndicators();filterIndicators($event.target.value)"
                                    (keyup.enter)="indicatorATrigger.closePanel();validateIndicatorInput(idx)">

                                <mat-error *ngIf="formGroupArr[idx].get('indicatorA').hasError('required')">
                                    {{ formGroupArr[idx].get('indicatorA').value
                                    && !isNotNumber(formGroupArr[idx].get('indicatorA').value) ?'Value' : 'Indicator'}}
                                    is required
                                </mat-error>
                                <mat-error *ngIf="formGroupArr[idx].get('indicatorA').hasError('min')">
                                    min value is 0.01
                                </mat-error>
                                <mat-error *ngIf="formGroupArr[idx].get('indicatorA').hasError('max')">
                                    max value is {{ MAX_ABSOLUTE_VALUE }}
                                </mat-error>

                            </mat-form-field>

                            <mat-form-field class="ut-pro-mat-form-field label-field spacer" appearance="outline"
                                color="accent">
                                <label class="ut-label">Comparator</label>

                                <input matInput [matAutocomplete]="comparatorAutocomplete" class="full-width"
                                    [formControl]="formGroupArr[idx].get('comparator')"
                                    (blur)="validateComparatorInput(idx)">

                                <mat-autocomplete #comparatorAutocomplete="matAutocomplete">
                                    <mat-option *ngFor="let comparator of COMPARATORS | keyvalue"
                                        [value]="comparator.value">
                                        {{ comparator.value }}
                                    </mat-option>
                                </mat-autocomplete>

                                <mat-error *ngIf="formGroupArr[idx].get('comparator').hasError('required')">
                                    Comparator is required
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field class="ut-pro-mat-form-field label-field spacer" appearance="outline"
                                color="accent">
                                <label class="ut-label">
                                    {{ isNotNumber(formGroupArr[idx].get('indicatorB').value) ? 'Indicator' : 'Value'}}
                                </label>

                                <input #indicatorBTrigger="matAutocompleteTrigger" matInput
                                    [matAutocomplete]="indicatorBAutoComplete" class="full-width"
                                    [formControl]="formGroupArr[idx].get('indicatorB')"
                                    (blur)="validateIndicatorInput(idx, true)" (focus)="getIndicators()"
                                    (keydown)="checkFilterEvent($event)"
                                    (keyup.backspace)="getIndicators();filterIndicators($event.target.value)"
                                    (keyup.enter)="indicatorBTrigger.closePanel();
                                        validateIndicatorInput(idx, true);
                                        openValueDialog(idx, true, indicatorBTrigger);">

                                <mat-autocomplete #indicatorBAutoComplete="matAutocomplete">
                                    <mat-option *ngFor="let indicator of indicatorList" [value]="indicator.name"
                                        (click)="openValueDialog(idx, true, indicatorBTrigger);getIndicators()">
                                        {{ indicator.name }}
                                    </mat-option>
                                </mat-autocomplete>

                                <mat-error *ngIf="formGroupArr[idx].get('indicatorB').hasError('required')">
                                    {{ isNotNumber(formGroupArr[idx].get('indicatorB').value) ? 'Indicator' : 'Value'}}
                                    is required
                                </mat-error>
                                <mat-error *ngIf="formGroupArr[idx].get('indicatorB').hasError('min')">
                                    min value is 0.01
                                </mat-error>
                                <mat-error *ngIf="formGroupArr[idx].get('indicatorB').hasError('max')">
                                    max value is {{ MAX_ABSOLUTE_VALUE }}
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </form>
                </div>
            </div>

            <div class="add-remove-button-container flex-centered-container-hr">
                <button mat-stroked-button color="accent" type="button" (click)="addForm()">
                    <mat-icon>add</mat-icon>
                </button>
                <button mat-stroked-button color="warn" type="button" (click)="removeForm()"
                    [disabled]="removeDisabled">
                    <mat-icon>clear</mat-icon>
                </button>
            </div>
        </div>

        <!-- <div class="action-button margin">
            <span class="add-new-button cursor-pointer margin-8 text-accent" (click)="addForm()">
                + Add another condition
            </span>
        </div> -->
    </div>
</div>